export default __webpack_public_path__ + "static/media/por-proofOfResidence.2534a9fb.png";